module.exports = __webpack_public_path__ + "static/media/google-drive-social-media-svgrepo-com.d40214e2.svg";